import DriverPlanEntryCheckoutEventUpdateRequest, {
  DriverPlanEntryCheckoutEventUpdateRequestBody,
} from "./driver-plan-entry-checkout-event-update.request";

const createBody = (
  request: DriverPlanEntryCheckoutEventUpdateRequest,
): DriverPlanEntryCheckoutEventUpdateRequestBody => {
  return {
    newHaltingTime: request.newHaltingTime,
    newHighwayCharge: request.newHighwayCharge,
  };
};

const driverPlanEntryCheckoutEventUpdateRequestFactory = {
  createBody,
};

export default driverPlanEntryCheckoutEventUpdateRequestFactory;
